<template>
  <v-autocomplete
    :label="label"
    :value="current"
    :items="candidate"
    :loading="loading"
    item-value="categoryId"
    item-text="categoryName"
    return-object
    :disabled="disabled"
    :rules="rules"
    @change="onSelected"
    no-data-text="入力内容に該当するカテゴリは存在しません"
    clearable
    filled
    dense
    :attach="attach"
  >
  </v-autocomplete>
</template>

<script>
export default {
  name: "CategoryField",
  model: { prop: "value", event: "selected" },
  props: {
    label: { type: String, default: "カテゴリー" },
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    attach: { type: Boolean, default: true },
    rules: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: null,
      candidate: [],
      current: null,
    };
  },
  async mounted() {
    await this.setup();
    this.apply(this.value);
  },
  watch: {
    value(value) {
      this.apply(value);
    },
  },
  methods: {
    async setup() {
      try {
        this.loading = true;
        const response = await this.$store.dispatch("category/search");
        if (response.data?.contents?.categorys) {
          this.candidate = response.data.contents.categorys;
        } else {
          this.candidate = [];
        }
      } catch (error) {
        console.error("CategoryField::setup", error);
      } finally {
        this.loading = false;
      }
    },
    apply(value) {
      if (value) {
        if (value == this.current?.categoryId) {
          // NOP
        } else {
          const current = this.candidate.find((c) => value === c.categoryId);
          this.onSelected(current);
        }
      } else {
        this.current = null;
      }
    },
    selected() {
      return this.current;
    },
    onSelected(value) {
      this.current = value;
      if (value) {
        this.$emit("selected", value.categoryId);
      } else {
        this.$emit("selected", null);
      }
    },
  },
};
</script>
